import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const syncHandle = args.listeners["syncHandle"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [];
    if (vo.row.canSync) {
      dealConf.push([
        "iconfont iczhongxintongbu_sel iconfont-adapt",
        "重新同步",
        () => {
          syncHandle(item);
        },
        "thirdLog:resend",
      ]);
    } else {
      dealConf.push([
        "iconfont iczhongxintongbu_nor iconfont-adapt-disabled",
        "重新同步",
        () => {
        },
        "thirdLog:resend",
      ]);
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [ 
    {
      label: "描述",
      prop: "operateDescription",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "参数",
      prop: "operateParams",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "返回结果",
      prop: "operateResult",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "耗时(ms)",
      prop: "operateTime",
      minWidth: "90"
    },
    {
      label: "结果",
      prop: "resultName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "操作时间",
      prop: "operateDate",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      width: "90",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
